const creditsafeTheme = {
  primaryColour: '#E93026',
  secondaryColour: '#D94033',
}

const equifaxTheme = {
  primaryColour: 'rgb(163,31,52)',
  secondaryColour: '#A31F34',
}

export const selectThemeColours = (partnerID) => {
  switch (partnerID) {
    case 'cs':
      return creditsafeTheme
    case 'efx':
      return equifaxTheme
    default:
      return creditsafeTheme
  }
}



// WEBPACK FOOTER //
// ./src/theme-colours.js